var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.taskMultiShow,
          expression: "taskMultiShow"
        }
      ],
      staticClass: "popup",
      attrs: { id: "transferMulti" }
    },
    [
      _c(
        "div",
        { staticClass: "content", attrs: { id: "sourceSelect" } },
        [
          _c("div", { staticClass: "title" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("language.popup.cloudTransferPopup.pleaSelect"))
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.taskMultiClose($event)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "sourceTree",
              staticClass: "task-content",
              attrs: { id: "tree-app" }
            },
            [
              _c(
                "el-scrollbar",
                { ref: "elscrollbar", staticStyle: { height: "100%" } },
                [
                  !_vm.realTimeMode
                    ? _c("div", [
                        !_vm.model.length && !_vm.loading
                          ? _c(
                              "div",
                              {
                                staticClass: "nondrive-des",
                                on: {
                                  click: function($event) {
                                    return _vm.toAddCloudPage()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\r\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "language.popup.cloudTransferPopup.addValidCloud"
                                      )
                                    ) +
                                    "\r\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    : _c("div", [
                        !_vm.model.length && !_vm.loading
                          ? _c(
                              "div",
                              {
                                staticClass: "real-nodrives",
                                on: {
                                  click: function($event) {
                                    return _vm.toAddCloudPage()
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "nondrive-realtime" }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "nondrive-realtimedes" },
                                  [
                                    _vm._v(
                                      "\r\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.cloudTransferPopup.addValidCloud"
                                          )
                                        ) +
                                        "\r\n                 "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                  _vm._v(" "),
                  _c("el-tree", {
                    ref: "tree",
                    attrs: {
                      lazy: "",
                      load: _vm.loadNode,
                      data: _vm.model,
                      props: _vm.defaultProps,
                      "check-on-click-node": false,
                      "node-key": "keyId",
                      "show-checkbox": true,
                      "expand-on-click-node": true,
                      "highlight-current": "",
                      "check-strictly": true
                    },
                    on: { "check-change": _vm.changeCheckStatus },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var node = ref.node
                            var data = ref.data
                            return _vm.openPanel
                              ? _c("span", { staticStyle: { width: "85%" } }, [
                                  _c("div", {
                                    staticClass: "tree-icon-position",
                                    class: [
                                      data.appName
                                        ? _vm.returnName(data.appName)
                                        : "small-file",
                                      data.dir
                                        ? _vm.matchfolderType(data.docType) +
                                          "-small folder-option-icon"
                                        : "",
                                      !data.dir && !data.appName
                                        ? _vm.matchfileType(data.name) +
                                          "-small folder-option-icon"
                                        : ""
                                    ]
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "node-name",
                                      attrs: { title: node.label }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm._f("ellipsis")(node.label))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showCreateSession(node),
                                          expression: "showCreateSession(node)"
                                        }
                                      ],
                                      staticClass: "create-session",
                                      attrs: {
                                        "data-id": node.id,
                                        title: _vm.$t(
                                          "language.popup.cloudExploerPopup.googlePhotosV2AddMore"
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.createSession(node)
                                        }
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "add-more-photos-icon"
                                      })
                                    ]
                                  )
                                ])
                              : _vm._e()
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "task-footer" }, [
            _c(
              "button",
              {
                staticClass: "task-button",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.multiSubmit()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
            )
          ]),
          _vm._v(" "),
          _c("onedriveBusinesFolderError", {
            ref: "onedriveBusinesFolderError"
          }),
          _vm._v(" "),
          _c("googlePhotosV2CreateDialog", {
            ref: "googlePhotosV2CreateDialog",
            on: { createFolder: _vm.handleCreateFolderGooglePhotos }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53d5bce3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53d5bce3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_transfer_popups/transfer_multi_popup.vue
// module id = null
// module chunks = 